import { call } from 'redux-saga/effects';
import { takeEveryAsync } from 'saga-toolkit';

import { AxiosResponse } from 'axios';
import { RequestOptions } from '../../../../types/RequestOptions';
import { responseBody } from '../../../../utils/parseResponse';
import request from '../../../../utils/request';
import {
  fetchEventWithTickets,
  fetchEventWithTicketsPayload,
  fetchVoucherData,
  fetchVoucherDataPayload,
} from './index';

const requestOptions: RequestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

function* fetchEventWithTicketsSaga(action: fetchEventWithTicketsPayload) {
  const { eventId, queryParams, extraIncludes } = action.meta.arg;
  let requestURL = `/event/${eventId}?include=type,ticketTypeGroups,tickets.ticketprice,tickets.ticketaddons,timeInterval,dateTimeFormat,location,cover,currency,numberOfPublicTicketTypes,numberOfPrivateTicketTypes,hasVoucher,customerform,hasRegistrationForm,walletcredit,fees_and_taxes,seller_public_information,sellerFeatures,merchantTaxName,checkoutConfiguration.displayAvailability`;

  if (extraIncludes.length > 0) {
    requestURL += ',' + extraIncludes.join(',');
  }

  if (queryParams.uuid) {
    requestURL += `&uuid=${queryParams.uuid}`;
  }

  if (queryParams?.tickets) {
    requestURL += `&tickets=${queryParams.tickets}`;
  }

  if (queryParams?.preview) {
    requestURL += '&preview=true';
  }

  const response: AxiosResponse = yield call(
    request,
    requestURL,
    requestOptions,
  );

  return response.data;
}

function* fetchVoucherDataSaga(action: fetchVoucherDataPayload) {
  const {
    meta: {
      arg: { eventId, voucherCode, uuid },
    },
  } = action;

  const response: AxiosResponse = yield call(
    request,
    `/event/${eventId}/apply_code/${voucherCode}?uuid=${uuid}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  );

  return { ...responseBody(response), voucherCode };
}

export function* ticketSaleSaga() {
  yield takeEveryAsync(fetchEventWithTickets.type, fetchEventWithTicketsSaga);
  yield takeEveryAsync(fetchVoucherData.type, fetchVoucherDataSaga);
}
